var _ellipse, _rect, _path, _path2, _path3, _path4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLightingFixure(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 857,
    height: 1230,
    viewBox: "0 0 857 1230",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M0 1230L336.382 355H520.617L857 1230H0Z",
    fill: "url(#paint0_linear_491_8469)",
    fillOpacity: 0.38,
    style: {
      mixBlendMode: "lighten"
    }
  }), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 431.672,
    cy: 354.878,
    rx: 37.8537,
    ry: 14.1951,
    fill: "#D9D9D9"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 422.209,
    width: 18.9268,
    height: 307.561,
    fill: "#115558"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M442.644 307.561H421.149C421.149 307.561 425.18 324.251 399.655 326.816C374.129 329.382 329.14 355.044 332.483 354.877H525.937C530.698 349.671 488.321 332.464 464.139 327.484C439.958 322.503 442.644 307.561 442.644 307.561Z",
    fill: "#115558"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M398.551 312.293L424.913 279.171H436.63L460.063 312.293H398.551Z",
    fill: "#115558"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M464.795 236.585C464.795 232.857 463.938 229.165 462.273 225.721C460.609 222.276 458.169 219.147 455.093 216.51C452.018 213.874 448.366 211.783 444.348 210.356C440.329 208.93 436.022 208.195 431.673 208.195C427.323 208.195 423.016 208.93 418.998 210.356C414.979 211.783 411.328 213.874 408.252 216.511C405.176 219.147 402.737 222.276 401.072 225.721C399.408 229.165 398.551 232.857 398.551 236.585L431.673 236.585H464.795Z",
    fill: "#115558"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M464.795 279.171C464.795 277.307 463.938 275.461 462.273 273.739C460.609 272.016 458.169 270.452 455.093 269.133C452.018 267.815 448.367 266.77 444.348 266.056C440.329 265.343 436.022 264.976 431.673 264.976C427.323 264.976 423.016 265.343 418.998 266.056C414.979 266.77 411.328 267.815 408.252 269.133C405.176 270.452 402.737 272.016 401.072 273.739C399.408 275.461 398.551 277.307 398.551 279.171L431.673 279.171L464.795 279.171Z",
    fill: "#115558"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_491_8469",
    x1: 428.5,
    y1: 355,
    x2: 428.5,
    y2: 1230,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E9FDFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8B9797",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLightingFixure);
export default __webpack_public_path__ + "static/media/Lighting Fixure.6ce7683d3371f94b0b46d2a5cecd6d28.svg";
export { ForwardRef as ReactComponent };